import { useEffect, useState } from 'react';
import { fetchPrcTransaction } from '../api/transactions';

export function usePrcTransaction(hash) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const normalized = String(hash || '').trim();
    if (!normalized) {
      setLoading(false);
      setError('Invalid PRC transaction hash.');
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setData(null);

    fetchPrcTransaction(normalized)
      .then((result) => {
        if (!cancelled) {
          setData(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.response?.data?.message || err.message || 'Transaction not found.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [hash]);

  return { data, loading, error, display: data?.display };
}
